import React from "react";
import { Color } from "../../types";

const StatusColorContext = React.createContext<{
  colors: Color[];
  setColors: any;
}>({ colors: [], setColors: () => {} });

export default StatusColorContext;
